export default {
    API_ENDPOINT: 'http://localhost:8000',
    TOKEN_KEY: process.env.REACT_APP_API_KEY
}